import * as incidentActions from '@innovyze/stylovyze/lib/actions/incidents.actions';
import { ActivityType, CreateActivityBody, } from '@innovyze/stylovyze/lib/types/activities.types';
import { put, retry, takeLatest } from 'redux-saga/effects';
import { error as notificationError, success, } from '@innovyze/stylovyze/lib/actions';
import { createActivity, getAlertByIdApi, getIncidents, } from '@innovyze/stylovyze/lib/services';
import { getAllSensorsType } from '@innovyze/stylovyze/lib/utils/typeUtils';
/**
 * Sagas
 */
function* incidentsSaga(action) {
    const { getIncidentsResolved, getIncidentsRejected } = incidentActions;
    try {
        const payload = yield retry(5, 1500, getIncidents, action.payload);
        yield put(getIncidentsResolved(payload.data));
    }
    catch (e) {
        yield put(getIncidentsRejected());
    }
}
function* addAlertToIncidentSaga(action) {
    const { addAlertToIncidentResolved, addAlertToIncidentRejected } = incidentActions;
    try {
        const alertByIdPayload = yield retry(5, 1500, getAlertByIdApi, action.payload.alertId);
        if (alertByIdPayload.data) {
            const createActivityBody = new CreateActivityBody(action.payload.incident.id, action.payload.incident.sequence, ActivityType.ALERT, {
                alertId: alertByIdPayload.data.id,
                name: alertByIdPayload.data.name,
                priority: alertByIdPayload.data.priority,
                sensorType: getAllSensorsType(alertByIdPayload.data.metadata?.sensors),
                generatedDate: alertByIdPayload.data.createDate,
            });
            const payload = yield retry(5, 1500, createActivity, createActivityBody);
            if (payload.data) {
                yield put(addAlertToIncidentResolved());
                yield put(success('Alert \'' +
                    alertByIdPayload.data.name +
                    '\' was successfully added to Incident \'' +
                    action.payload.incident.name +
                    '\''));
            }
            else
                yield put(addAlertToIncidentRejected());
        }
        else
            yield put(addAlertToIncidentRejected());
    }
    catch (e) {
        yield put(notificationError('Error Creating Alert Activity'));
        yield put(addAlertToIncidentRejected());
    }
}
function* getIncidentByAlertIdSaga(action) {
    const { getIncidentByAlertIdResolved, getIncidentByAlertIdRejected } = incidentActions;
    try {
        const payload = yield retry(5, 1500, getIncidents, action.payload);
        yield put(getIncidentByAlertIdResolved(payload.data));
    }
    catch (e) {
        yield put(notificationError('Error Getting Incident By Id'));
        yield put(getIncidentByAlertIdRejected());
    }
}
/**
 * Watcher Sagas
 */
function* watchGetIncidents() {
    yield takeLatest(incidentActions.getIncidents, incidentsSaga);
}
function* watchAddAlertToIncident() {
    yield takeLatest(incidentActions.addAlertToIncident, addAlertToIncidentSaga);
}
function* watchGetIncidentByAlertId() {
    yield takeLatest(incidentActions.getIncidentByAlertId, getIncidentByAlertIdSaga);
}
export default [
    watchGetIncidents(),
    watchAddAlertToIncident(),
    watchGetIncidentByAlertId(),
];
